// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__lmZFi","buttons":"Footer_buttons__f8Yfu"};